import { Box, Button, Typography} from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import NavigatePage from '../components/NavigatePage/NavigatePage'
import { useGet } from '../hooks/useApi'
import SidebarForm from '../components/CheckoutSidebar/SidebarForm'
import { useLocation, useNavigate } from 'react-router-dom'
import AppModal from '../components/Modal/AppModal'
import CheckCircle from '../assets/DigitalCoursesAsset/checkcircle.svg';
import { useParams } from 'react-router-dom'


export default function GiftCheckoutForm() {
  const {id} = useParams()
  const location = useLocation(); // Access the current location (URL)
  
  // Parse query parameters from the URL
  const queryParams = new URLSearchParams(location.search); // Extract query string
  
  const productId = queryParams.get('productId'); // Get the productId
  
  const [onClose, setOnClose] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const messageContent = {
   beforeSpan: "Congratulations! You’ve successfully completed payment for order  ",
   spanContent: "#123456,",
   afterSpan: "  your tracking code will be sent to your whatsappa and your email within 48 hours"
 };
 const navigate = useNavigate()

 const handleGiftHistoryClick = () =>{
   navigate('/product/order-history')
 }
 const handleTrackingClick = () =>{
   navigate('/product/track-order')
 }
 const { data: itemDetails, error: itemErr, isLoading: itemLoader} = useGet(`/api/GiftItems/get-item-details/${productId}`);
   const item = itemDetails?.data
   console.log('g',itemDetails)
   const { data: validateCustomer} = useGet('/api/GiftItems/validate-Customer');
   const customerId = validateCustomer?.data.userEmail
   console.log(customerId)
 const { 
   data: giftOrderHistory, 
   error: giftOrderErr, 
   isLoading: giftOrderLoader 
 } = useGet(`api/GiftItemOrders/order-history?userEmail=${customerId}`);
 const giftOrderItems = useMemo(() => giftOrderHistory?.data || [], [giftOrderHistory]);
 console.log('ts',giftOrderItems)

  
  const [showGift, setShowGift] = useState(null); // State to store the selected course
  const [fetchedGift, setFetchedGift] = useState(null); // State to store courses after fetch

 

  // Only fetch courses once
  useEffect(() => {
    if (giftOrderHistory && !fetchedGift) {
      setFetchedGift(giftOrderHistory.data); // Save the fetched courses in the state
    }
  }, [giftOrderHistory, fetchedGift]); // Only run when courses change or courses haven't been set yet

  useEffect(() => {
    if (fetchedGift?.length > 0) {
      const foundGift = fetchedGift.find(gift => {
        console.log('giftId from list:', gift.productId
          ); // Log each courseId
        console.log('compare g', Number(gift.productId
          ) === Number(productId));
        return Number(gift.productId) === Number(productId);
      });

      setShowGift(foundGift); // Set the course once it's found
    }

    console.log('s',showGift);
    
  }, [fetchedGift, productId,showGift]); // Only run when courses or productId change
  return (
    <Box > 

        <NavigatePage />
        <SidebarForm setOnClose={setOnClose} setOpenModal={setOpenModal}/>
        {openModal  && <AppModal setShowModal={setOpenModal} showModal={openModal} icon={CheckCircle} title='Purchase Successful.' message={messageContent} >
        <Box sx={{border: '1px solid #D2D1D6', borderRadius: '8px', padding: {md: 2, xs: 1}, display:'flex', flexDirection:'column', width:'100%', marginTop: 4}}>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',fontFamily: theme=> theme.typography.smallText,}}>
              <Typography sx={{textTransform:'capitalize', fontSize: 12}}>
                Gift Item Purchased
              </Typography>
              <Typography sx={{textTransform:'capitalize', fontSize: 12}}>{showGift?.productName}</Typography>
           
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              quantity
              </Typography>
              <Typography sx={{fontSize: 12}}>{showGift?.quantity} Unit</Typography>
             
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between',marginTop: 1,fontSize: 12}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              price
              </Typography>
              <Typography sx={{fontSize: 12}}>₦{showGift?.pricePerUnit}</Typography>
             
             </Box>
             <Box sx={{borderBottom: '1px solid #D2D1D6', marginBottom: 1, display:'flex', justifyContent:'space-between'}}>
              <Typography sx={{textTransform:'capitalize',fontSize: 12}}>
              order I.D
              </Typography>
              <Typography sx={{fontSize: 12}}>{showGift?.orderId
}</Typography>
             
             </Box>
           </Box>
           <Box sx={{display:'flex', flex: 1, alignItems:'center', justifyContent: 'space-between', marginTop: {md: 4, xs: 2},marginBottom: {md: 0, xs: 2}, width: '100%'}}>



 {/* Add to Favorites Button  */}
<Box sx={{ marginTop: 1,width: 'auto' }}>
  <Button
  onClick={handleGiftHistoryClick}
    variant="contained"
    color="secondary"
    sx={{
      width: '100%',
      
      padding: {md: '10px 20px', xs: '5px 8px'},
      border: '1px solid #CBB1FC',
      borderRadius: '25px',
     
      textTransform:'capitalize',
      backgroundColor:'#fff',
      color:'#5604F6',
   
    }}
  >
    view recent orders
  </Button>
</Box>



<Box sx={{ marginTop: 2, width: 'auto'}}>
  <Button
    variant="contained"
    color="success"
    onClick={handleTrackingClick}
    sx={{
      width: '100%',
      padding: {md: '10px 20px', xs: '5px 8px'},
      borderRadius: '25px',
        textTransform:'capitalize',
        backgroundColor: '#5604F6',
        color:'#fff'
    }}
  >
    Track your order
  </Button>
</Box>
</Box>
<Box sx={{alignSelf:'flex-start', marginTop: 2}}>
  <Typography>Need help?</Typography>
  <Typography>
  Contact our support team via <span style={{color: '#F6A704', cursor:'pointer'}}>WhatsApp or email</span>   for assistance.</Typography>
</Box> 
          
          </AppModal>}
    </Box>
  )
}
